import { PropsDiff } from '@seddi/core';

import { type MockupLogo, logoTextureImageSrc } from '../types/mockupLogos';

/**
 * Compute diff between previous and next logo arrays.
 * Returns tuples of [prev, next] for each changed logo (added, removed, or updated).
 */
export const getDiffLogos = (
  prev: Readonly<MockupLogo[]>,
  next: Readonly<MockupLogo[]>,
): [MockupLogo | undefined, MockupLogo | undefined][] => {
  const prevProps = prev.reduce((map, l) => {
    map[l.id] = l;
    return map;
  }, {} as Record<string, MockupLogo>);
  const nextProps = next.reduce((map, l) => {
    map[l.id] = l;
    return map;
  }, {} as Record<string, MockupLogo>);
  const idsFromProps = PropsDiff.diff(nextProps, prevProps);
  const idsFromImage = next
    .filter(
      l =>
        prevProps[l.id] &&
        (prevProps[l.id].imageSrc !== l.imageSrc ||
          logoTextureImageSrc(prevProps[l.id]) !== logoTextureImageSrc(l)),
    )
    .map(l => l.id);
  const ids = [...new Set([...idsFromProps, ...idsFromImage])];
  return ids.map(id => [prevProps[id], nextProps[id]]);
};
